
export default {
  name: 'BaseProfileAuthorCoverChange',
  data() {
    return {
      image: {
        src: this.avatar,
        type: null,
      },
      zoom: 0,
    }
  },
  destroyed() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src)
    }
  },
  methods: {
    onChange() {
      const cropper = this.$refs.cropper_cover
      if (cropper) {
        const { coordinates, imageSize } = cropper
        if (
          imageSize.width / imageSize.height >
          coordinates.width / coordinates.height
        ) {
          this.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight)
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth)
        }
      }
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      }
    },
    loadImage(event) {
      const { files } = event.target
      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src)
        }
        const blob = URL.createObjectURL(files[0])
        const reader = new FileReader()
        reader.onload = (e) => {
          this.image = {
            src: blob,
            type: this.getMimeType(e.target.result, files[0].type),
          }
        }
        reader.readAsArrayBuffer(files[0])

        setTimeout(() => {
          this.$refs.crop_cover_popup.open()
        }, 100)
      }
    },
    getMimeType(file, fallback = null) {
      const byteArray = new Uint8Array(file).subarray(0, 4)
      let header = ''
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16)
      }
      switch (header) {
        case '89504e47':
          return 'image/png'
        case '47494638':
          return 'image/gif'
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
          return 'image/jpeg'
        default:
          return fallback
      }
    },

    onZoom(value) {
      const cropper = this.$refs.cropper_cover
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight
          const imageHeight = cropper.imageSize.height
          // Determine the current absolute zoom and the new absolute zoom
          // to calculate the sought relative zoom value
          cropper.zoom(
            (imageHeight - this.zoom * (imageHeight - minHeight)) /
              (imageHeight - value * (imageHeight - minHeight))
          )
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth
          const imageWidth = cropper.imageSize.width
          cropper.zoom(
            (imageWidth - this.zoom * (imageWidth - minWidth)) /
              (imageWidth - value * (imageWidth - minWidth))
          )
        }
      }
    },

    _confirm() {
      const { canvas } = this.$refs.cropper_cover.getResult()
      canvas.toBlob(async (blob) => {
        const cover = await this.uploadImg(blob)
        await this.updateUserCover(cover.file.url)
        this.$emit('change-cover')
        this.$auth.fetchUser()
        this._cancel()
      }, this.image.type)
    },

    _cancel() {
      this.$refs.crop_cover_popup.close()
      this.reset()
    },

    async uploadImg(blob) {
      const formData = new FormData()
      const isDev = process.env.NODE_ENV !== 'production'
      formData.append('file', blob)
      formData.append('width', 1920)
      return await this.$axios.$post(
        isDev
          ? 'http://localhost:4001/file/upload/img'
          : 'https://api.megasreda.ru/file/upload/img',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
    },
    async updateUserCover(cover) {
      try {
        if (this.$auth.user.type === 'COMPANY') {
          await this.$axios.$put('/users/update', {
            company: { ...this.$auth.user.company, cover },
          })
        } else {
          await this.$axios.$put('/users/update', {
            profile: { ...this.$auth.user.profile, cover },
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
